export const REJECTED_REASONS = [
  { code: 'not_requested', label: 'Enquiry not requested / accidental contact' },
  { code: 'incorrect_invalid_number', label: 'Wrong or invalid number' },
  { code: 'fake_lead', label: 'Spam or fake enquiry' },
  { code: 'no_query', label: 'No relevant enquiry' },
  { code: 'other_reason', label: 'Other reason' },
];

export const LOST_REASONS = [
  { code: 'no_issue', label: 'No fertility concern / not needed' },
  { code: 'chose_other_provider', label: 'Chose another provider' },
  { code: 'cost', label: 'Cost / affordability' },
  { code: 'location', label: 'Location / travel' },
  { code: 'no_longer_proceeding', label: 'No longer proceeding' },
  { code: 'other_reason', label: 'Other reason' },
];

export function closureReasonError(status: string, reason?: string, detail?: string) {
  if (status !== 'lost' && status !== 'invalid_lead') return null;
  const options = status === 'lost' ? LOST_REASONS : REJECTED_REASONS;
  if (!options.some((option) => option.code === reason)) return 'Select a valid reason for this disposition';
  if (reason === 'other_reason' && !detail?.trim()) return 'Add a short reason when choosing Other';
  return null;
}
